import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    hidden: true,
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/index'),
        meta: {title: '首页'}
      }
    ]
  }
]

export const asyncRouterMap = [
  {
    path:'/user',
    component: Layout,
    redirect: '/user/list',
    name: 'user',
    meta: {title: '用户管理', icon: 'user'},
    children: [
      {
        path: 'list',
        name: 'userList',
        component: () => import('@/views/user/list/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'buyCanRecord',
        name: 'buyCanRecord',
        component: () => import('@/views/user/buyCanRecord/index.vue'),
        meta: {title: '购物券记录', icon: 'table'}
      }
    ]
  },
  {
    path: '/register',
    component: Layout,
    redirect: '/register/nodeEdit',
    name: 'register',
    meta: {title: '接点与注册', icon: 'tree'},
    children: [
      {
        path: 'nodeEdit',
        name: 'nodeEdit',
        component: () => import('@/views/register/nodeEdit/index.vue'),
        meta: {title: '接点修改', icon: 'tree'}
      },
      {
        path: 'relationship',
        name: 'relationship',
        component: () => import('@/views/register/relationship/index.vue'),
        meta: {title: '接点查询', icon: 'tree'}
      },
      {
        path: 'zhongcheng-relation-report',
        name: 'zhongcheng-relation-report',
        component: () => import('@/views/zhongcheng/relationReport/index.vue'),
        meta: {title: '关系报表', icon: 'table'}
      },
      {
        path: 'abnormalAccount',
        name: 'abnormalAccount',
        component: () => import('@/views/register/abnormalAccount/index.vue'),
        meta: {title: '异常账号', icon: 'table'}
      },
      {
        path: 'editRecord',
        name: 'editRecord',
        component: () => import('@/views/register/editRecord/index.vue'),
        meta: {title: '修改记录', icon: 'table'}
      },
      {
        path: 'helpRegister',
        name: 'helpRegister',
        component: () => import('@/views/register/helpRegister/index.vue'),
        meta: {title: '帮人注册', icon: 'ums-admin'}
      },
      {
        path: 'registerRecord',
        name: 'registerRecord',
        component: () => import('@/views/register/registerRecord/index.vue'),
        meta: {title: '注册记录', icon: 'table'}
      }
    ]
  },
  {
    path:'/finance',
    component: Layout,
    redirect: '/finance/reward',
    name: 'finance',
    alwaysShow: true,
    meta: {title: '财务管理', icon: 'total-today'},
    children: [
      {
        path: 'reward',
        name: 'memberRewardList',
        component: () => import('@/views/user/reward/index'),
        meta: {title: '奖金记录', icon: 'total-today'}
      },
      {
        path: 'performance',
        name: 'performanceList',
        component: () => import('@/views/user/performance/index.vue'),
        meta: {title: '业绩统计', icon: 'total-today'}
      },
      {
        path: 'zhongcheng-performance',
        name: 'zhongcheng-performance-list',
        component: () => import('@/views/finance/zhongchengPerformance/index.vue'),
        meta: {title: '业绩统计', icon: 'total-today'}
      },
      {
        path: 'withdraw',
        name: 'memberWithdrawList',
        component: () => import('@/views/user/withdraw/index'),
        meta: {title: '提现记录', icon: 'table'}
      },
      {
        path: 'recharge',
        name: 'memberRechargeList',
        component: () => import('@/views/user/recharge/index'),
        meta: {title: '充值管理', icon: 'table'}
      },
      {
        path: 'rechargeRecord',
        name: 'memberRechargeRecordList',
        component: () => import('@/views/finance/rechargeRecord/index'),
        meta: {title: '充值记录', icon: 'table'}
      },
      {
        path: 'monthlySettle',
        name: 'monthlySettleList',
        component: () => import('@/views/finance/monthlySettle/index'),
        meta: {title: '月结记录', icon: 'total-today'}
      },
      {
        path: 'walletChange',
        name: 'walletChangeList',
        component: () => import('@/views/finance/walletChange/index'),
        meta: {title: '钱包变更', icon: 'table'}
      },
      {
        path: 'assetManagement',
        name: 'assetManagementList',
        component: () => import('@/views/finance/assetManagement/index.vue'),
        meta: {title: '资产管理', icon: 'table'}
      },
      {
        path: 'performanceEdit',
        name: 'performanceEdit',
        component: () => import('@/views/finance/performanceEdit/index.vue'),
        meta: {title: '业绩修改', icon: 'table'}
      },
      {
        path: 'assetFlowRecord',
        name: 'assetFlowRecordList',
        component: () => import('@/views/finance/assetFlowRecord/index.vue'),
        meta: {title: '资产流水记录', icon: 'table'}
      },
      {
        path: 'assetStat',
        name: 'assetStatList',
        component: () => import('@/views/finance/assetStat/index.vue'),
        meta: {title: '资产统计管理', icon: 'table'}
      },
      {
        path: 'dailySettle',
        name: 'dailySettleList',
        component: () => import('@/views/finance/dailySettle/index'),
        meta: {title: '日结记录', icon: 'total-today'}
      },
      {
        path: 'accountDetail',
        name: 'zhongcheng-account-detail',
        component: () => import('@/views/finance/incomeRecord/index.vue'),
        meta: {title: '收益记录', icon: 'table'}
      }
    ]
  },
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '商品', icon: 'product'},
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: {title: '商品列表', icon: 'product-list'}
    },
    {
      path: 'productPendingReview',
      name: 'productPendingReview',
      component: () => import('@/views/pms/product/index'),
      meta: {title: '待审核商品', icon: 'product-list'}
    },
      {
        path: 'reconsumeProduct',
        name: 'reconsumeProduct',
        component: () => import('@/views/pms/reconsumeProduct/index'),
        meta: {title: '复消产品管理', icon: 'product-list'}
      },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加商品', icon: 'product-add'}
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改商品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '商品分类', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加商品分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改商品分类'},
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {title: '商品类型', icon: 'product-attr'}
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {title: '商品属性列表'},
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {title: '添加商品属性'},
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {title: '修改商品属性'},
        hidden: true
      },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/pms/brand/index'),
        meta: {title: '品牌管理', icon: 'product-brand'}
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: {title: '添加品牌'},
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: {title: '编辑品牌'},
        hidden: true
      }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'zhongcheng-order',
        name: 'zhongcheng-order-list',
        component: () => import('@/views/zhongcheng/order/index.vue'),
        meta: {title: '众成订单列表', icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {title: '发货列表'},
        hidden:true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {title: '订单设置', icon: 'order-setting'}
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: {title: '退货申请处理', icon: 'order-return'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {title: '退货原因设置', icon: 'order-return-reason'}
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {title: '退货原因详情'},
        hidden:true
      }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {title: '营销', icon: 'sms'},
    children: [
      {
        path: 'flash',
        name: 'flash',
        component: () => import('@/views/sms/flash/index'),
        meta: {title: '秒杀活动列表', icon: 'sms-flash'}
      },
      {
        path: 'flashSession',
        name: 'flashSession',
        component: () => import('@/views/sms/flash/sessionList'),
        meta: {title: '秒杀时间段列表'},
        hidden:true
      },
      {
        path: 'selectSession',
        name: 'selectSession',
        component: () => import('@/views/sms/flash/selectSessionList'),
        meta: {title: '秒杀时间段选择'},
        hidden:true
      },
      {
        path: 'flashProductRelation',
        name: 'flashProductRelation',
        component: () => import('@/views/sms/flash/productRelationList'),
        meta: {title: '秒杀商品列表'},
        hidden:true
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: {title: '优惠券列表', icon: 'sms-coupon'}
      },
      {
        path: 'sign',
        name: 'sign',
        component: () => import('@/views/sms/sign/index'),
        meta: {title: '签到管理', icon: 'sms'}
      },
      {
        path: 'signRecord',
        name: 'signRecord',
        component: () => import('@/views/sms/signRecord/index'),
        meta: {title: '签到记录', icon: 'table'}
      },
      {
        path: 'lotteryPrize',
        name: 'lotteryPrize',
        component: () => import('@/views/sms/lotteryPrize/index'),
        meta: {title: '抽奖奖品管理', icon: 'sms'}
      },
      {
        path: 'package',
        name: 'packageList',
        component: () => import('@/views/pms/package/index.vue'),
        meta: {title: '套餐列表', icon: 'product-list'}
      },
      {
        path: 'addPackage',
        name: 'addPackage',
        component: () => import('@/views/pms/package/add.vue'),
        meta: {title: '添加套餐', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updatePackage',
        name: 'updatePackage',
        component: () => import('@/views/pms/package/update.vue'),
        meta: {title: '修改套餐', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: {title: '添加优惠券'},
        hidden:true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: {title: '修改优惠券'},
        hidden:true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: {title: '优惠券领取详情'},
        hidden:true
      },
      {
        path: 'brand',
        name: 'homeBrand',
        component: () => import('@/views/sms/brand/index'),
        meta: {title: '品牌推荐', icon: 'product-brand'}
      },
      {
        path: 'new',
        name: 'homeNew',
        component: () => import('@/views/sms/new/index'),
        meta: {title: '新品推荐', icon: 'sms-new'}
      },
      {
        path: 'hot',
        name: 'homeHot',
        component: () => import('@/views/sms/hot/index'),
        meta: {title: '人气推荐', icon: 'sms-hot'}
      },
      {
        path: 'subject',
        name: 'homeSubject',
        component: () => import('@/views/sms/subject/index'),
        meta: {title: '专题推荐', icon: 'sms-subject'}
      },
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: {title: '广告列表', icon: 'sms-ad'}
      },
      {
        path: 'homeNews',
        name: 'homeNews',
        component: () => import('@/views/sms/homeNews/index'),
        meta: {title: '消息列表', icon: 'sms-ad'}
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: {title: '添加广告'},
        hidden:true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: {title: '编辑广告'},
        hidden:true
      }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'systemSwitch',
        name: 'systemSwitch',
        component: () => import('@/views/ums/systemSwitch/index.vue'),
        meta: {title: '系统切换', icon: 'ums-admin'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {
    path: '/news',
    component: Layout,
    redirect: '/news/list',
    name: 'news',
    alwaysShow: true,
    meta: {title: '新闻管理', icon: 'cms'},
    children: [
      {
        path: 'category',
        name: 'newsCategory',
        component: () => import('@/views/news/category/index'),
        meta: {title: '新闻分类', icon: 'cms-subject'}
      },
      {
        path: 'list',
        name: 'newsList',
        component: () => import('@/views/news/list/index'),
        meta: {title: '新闻列表', icon: 'table'}
      }
    ]
  },
  {
    path: '/log',
    component: Layout,
    redirect: '/log/operation',
    name: 'log',
    alwaysShow: true,
    meta: {title: '日志管理', icon: 'document'},
    children: [
      {
        path: 'operation',
        name: 'operationLog',
        component: () => import('@/views/log/operation/index'),
        meta: {title: '操作日志', icon: 'table'}
      }
    ]
  },
  {
    path:'/reb',
    component: Layout,
    redirect: '/reb/rebate',
    name: 'reb',
    meta: {title: '返利池', icon: 'order'},
    children: [
      {
        path: 'rebate',
        name: 'rebatePoolList',
        component: () => import('@/views/reb/rebate/index.vue'),
        meta: {title: '返利池', icon: 'order'}
      }
    ]
  },
  {
    path:'/integral',
    component: Layout,
    redirect: '/integral/integral',
    name: 'integral',
    meta: {title: '积分商城', icon: 'order'},
    children: [
      {
        path: 'integral',
        name: 'integralList',
        component: () => import('@/views/integral/integral/index.vue'),
        meta: {title: '积分商城', icon: 'order'}
      },
      {
        path: 'addIntegralProduct',
        name: 'addIntegralProduct',
        component: () => import('@/views/integral/integral/add.vue'),
        hidden: true,
        meta: {title: '添加积分商品', icon: 'product-add'}
      },
      {
        path: 'updateIntegralProduct',
        name: 'updateIntegralProduct',
        component: () => import('@/views/integral/integral/update.vue'),
        hidden: true,
        meta: {title: '编辑积分商品', icon: 'product-add'}
      }
    ]
  },
  {
    path:'/fumi',
    component: Layout,
    redirect: '/fumi/mall',
    name: 'fumi',
    meta: {title: '兑换券商城', icon: 'order'},
    children: [
      {
        path: 'mall',
        name: 'fumiMallList',
        component: () => import('@/views/fumi/mall/index.vue'),
        meta: {title: '兑换券商城', icon: 'order'}
      },
      {
        path: 'record',
        name: 'fumiRecord',
        component: () => import('@/views/fumi/record/index.vue'),
        meta: {title: '兑换券记录', icon: 'order'}
      },
      {
        path: 'grantStats',
        name: 'fumiGrantStats',
        component: () => import('@/views/fumi/grantStats/index.vue'),
        meta: {title: '兑换券变动', icon: 'order'}
      },
      {
        path: 'addFumiProduct',
        name: 'addFumiProduct',
        component: () => import('@/views/fumi/mall/add.vue'),
        hidden: true,
        meta: {title: '添加兑换券商品', icon: 'product-add'}
      },
      {
        path: 'updateFumiProduct',
        name: 'updateFumiProduct',
        component: () => import('@/views/fumi/mall/update.vue'),
        hidden: true,
        meta: {title: '编辑兑换券商品', icon: 'product-add'}
      }
    ]
  },
  {
    path: '/life',
    component: Layout,
    redirect: '/life/list',
    name: 'life',
    alwaysShow: true,
    meta: {title: '生活馆管理', icon: 'marker'},
    children: [
      {
        path: 'list',
        name: 'lifeList',
        component: () => import('@/views/life/list/index.vue'),
        meta: {title: '生活馆列表', icon: 'table'}
      }
    ]
  },
  {
    path: '/config',
    component: Layout,
    redirect: '/config/list',
    name: 'config',
    alwaysShow: true,
    meta: {title: '配置管理', icon: 'ums-menu'},
    children: [
      {
        path: 'list',
        name: 'configList',
        component: () => import('@/views/config/list/index.vue'),
        meta: {title: '配置列表', icon: 'table'}
      },
      {
        path: 'domain',
        name: 'domainList',
        component: () => import('@/views/config/domain/index.vue'),
        meta: {title: '域名管理', icon: 'table'}
      }
    ]
  },
  {
    path: '/supplier-my',
    component: Layout,
    redirect: '/supplier-my/info',
    name: 'supplier-my',
    alwaysShow: true,
    meta: {title: '我的', icon: 'user'},
    children: [
      {
        path: 'info',
        name: 'supplier-info',
        component: () => import('@/views/supplierPortal/my/info'),
        meta: {title: '供应商信息', icon: 'ums-admin'}
      },
      {
        path: 'dashboard',
        name: 'supplier-dashboard',
        component: () => import('@/views/supplierPortal/my/dashboard'),
        meta: {title: '数据面板', icon: 'dashboard'}
      }
    ]
  },
  {
    path: '/supplier-product',
    component: Layout,
    redirect: '/supplier-product/list',
    name: 'supplier-product',
    meta: {title: '商品管理', icon: 'product'},
    children: [
      {
        path: 'list',
        name: 'supplier-product-list',
        component: () => import('@/views/supplierPortal/product/list'),
        meta: {title: '商品列表', icon: 'product-list'}
      },
      {
        path: 'add',
        name: 'supplier-product-add',
        component: () => import('@/views/supplierPortal/product/add'),
        meta: {title: '添加商品', icon: 'product-add'}
      },
      {
        path: 'update',
        name: 'supplier-product-update',
        component: () => import('@/views/supplierPortal/product/update'),
        meta: {title: '修改商品'},
        hidden: true
      }
    ]
  },
  {
    path: '/supplier-order',
    component: Layout,
    redirect: '/supplier-order/list',
    name: 'supplier-order',
    meta: {title: '订单管理', icon: 'order'},
    children: [
      {
        path: 'list',
        name: 'supplier-order-list',
        component: () => import('@/views/supplierPortal/order/list'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'after-sales',
        name: 'supplier-after-sales-order',
        component: () => import('@/views/supplierPortal/order/afterSales'),
        meta: {title: '售后订单', icon: 'order-return'}
      }
    ]
  },
  {
    path: '/supplier-finance',
    component: Layout,
    redirect: '/supplier-finance/bill-record',
    name: 'supplier-finance',
    meta: {title: '财务管理', icon: 'total-today'},
    children: [
      {
        path: 'bill-record',
        name: 'supplier-bill-record',
        component: () => import('@/views/supplierPortal/finance/billRecord'),
        meta: {title: '账单记录', icon: 'table'}
      },
      {
        path: 'transfer-application',
        name: 'supplier-transfer-application',
        component: () => import('@/views/supplierPortal/finance/transferApplication'),
        meta: {title: '转账申请', icon: 'wallet'}
      },
      {
        path: 'settings',
        name: 'supplier-finance-settings',
        component: () => import('@/views/supplierPortal/finance/settings'),
        meta: {title: '财务设置', icon: 'settings'}
      },
      {
        path: 'reconciliation',
        name: 'supplier-reconciliation',
        component: () => import('@/views/supplierPortal/finance/reconciliation'),
        meta: {title: '对账管理', icon: 'clipboard-list'}
      }
    ]
  },
  {
    path: '/supplier',
    component: Layout,
    redirect: '/supplier/manage',
    name: 'supplier',
    meta: {title: '供应商管理', icon: 'ums'},
    children: [
      {
        path: 'manage',
        name: 'supplierManage',
        component: () => import('@/views/supplier/manage/index.vue'),
        meta: {title: '供应商管理', icon: 'ums-admin'}
      },
      {
        path: 'order',
        name: 'supplierOrder',
        component: () => import('@/views/supplier/order/index.vue'),
        meta: {title: '订单管理', icon: 'order'}
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js